module.exports = __webpack_public_path__ + "img/pic_map_australia_S.70b995cc.jpg";